module.exports = __webpack_public_path__ + "img/636901621592817205.41737d06.gif";